import { api } from '@/config/api';

// ─── Analytics ────────────────────────────────────────────────────────────────

export interface AiAnalyticsSummary {
  conversationsWithAi: number;
  totalAiReplies: number;
  aiQualifiedLeads: number;
  qualificationRate: number;
  maxTurnsDropoffs: number;
  humanHandoffsRequested: number;
  costCapHits: number;
  totalCostUsd: number;
  totalTokens: number;
  avgTokensPerReply: number;
}

export interface AiAnalyticsTopIntent {
  toolName: string;
  count: number;
  successCount: number;
}

export interface AiAnalyticsTimeSeriesPoint {
  date: string;
  aiReplies: number;
  qualifiedLeads: number;
  costUsd: number;
}

export interface AiAnalyticsResult {
  summary: AiAnalyticsSummary;
  topIntents: AiAnalyticsTopIntent[];
  series: AiAnalyticsTimeSeriesPoint[];
  byProvider: Array<{ provider: string; replies: number; tokens: number; costUsd: number }>;
}

export interface AiAnalyticsFilter {
  from?: string;  // ISO
  to?: string;    // ISO
}

export const aiAnalyticsService = {
  getOverview: async (filter: AiAnalyticsFilter = {}): Promise<AiAnalyticsResult> => {
    const r = await api.get('/slighter_crm/leads/analytics/ai-conversations', { params: filter });
    return r.data;
  },
};

// ─── Debug log (admin-only) ───────────────────────────────────────────────────

export interface AiDebugLog {
  debugLogUid: string;
  companyUid: string;
  leadUid: string;
  waMessageId?: string;
  leadEventUid?: string;
  provider?: string;
  model?: string;
  systemPrompt: string;
  transcript: Array<{ role: string; content?: string; toolCallId?: string }>;
  toolsOffered: Array<{ name: string; description?: string }>;
  firstReplyText?: string;
  firstReplyToolCalls: Array<{
    id?: string;
    name: string;
    arguments: Record<string, unknown>;
  }>;
  toolResults: Array<{
    name: string;
    result: { ok: boolean; message: string; recordUid?: string; sideEffect?: string };
  }>;
  finalReplyText?: string;
  tokensIn: number;
  tokensOut: number;
  createdAt: string;
}

export const aiDebugService = {
  getByLeadEvent: async (leadEventUid: string): Promise<AiDebugLog> => {
    const r = await api.get(`/slighter_crm/leads/ai-debug/by-event/${leadEventUid}`);
    return r.data;
  },
};
